import Uitslagen from './Uitslagen';
export default Uitslagen;